export const formatPercent = (val?: number, decimals = 2) => {
    if (val === null || val === undefined || isNaN(val)) {
        return null;
    }
    return (val * 100).toFixed(decimals) + '%';
};
